import * as React from 'react';

export const ScreenContext = React.createContext();
export const StateContext = React.createContext();
export const ErrorContext = React.createContext();
export const StartContext = React.createContext();
export const PingContext = React.createContext();
